import {
    getIsApiPending,
    getAccessToken,
    getPaymentsForm,
    getStkData,
    getStatusApiCallStatus,
    getPaymentsDetails,
} from '../../../selectors/travelSs/payments';
import { getUgxPremium } from '../../../selectors/travelSs/quote';

import {
    apiTransitionStkPush,
    apiTransitionPaymentsStatus,
    triggerPaymentsStkPushSuccess,
    triggerPaymentsStkPushFailure,
    checkPaymentsStatusSuccess,
    checkPaymentsStatus,
} from '../../../actions/travelSs/payments';
import axios from 'axios';
import { getIsApiPaymentStatusPending } from '../../../selectors/roaCarInsurance/payments';
import { setExpiredAuth } from '../../../actions/travelSs/quote';
import { getPayloadCollection } from '../../../selectors/travelSs/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/travelSs/payloadCollection';

const clearIntervalId = (intervalId) => {
    clearInterval(intervalId);
    intervalId = null;
};

let intervalId = null;
export const paymentsStkService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();

    (async () => {
        const pushIsPending = getIsApiPending(state);

        if (!pushIsPending) {
            store.dispatch(apiTransitionStkPush.pending());
            try {
                const resp = await triggerStkPush(state);
                console.log(resp, ":fgdfgjgg")
                store.dispatch(triggerPaymentsStkPushSuccess(resp.data));
                const uuid = getPayloadCollection(store.getState()).uuid;
                const transactionReference = getStkData(state)?.referenceId;
                await checkPaymentStatus(store, transactionReference, uuid);


                // store.dispatch(apiTransitionStkPush.success());
                // intervalId = setInterval(() => {
                //     //Dispatch checkPaymentsStatus
                //     store.dispatch(checkPaymentsStatus());
                //     if (getStatusApiCallStatus(state) === 'success') {
                //         clearInterval(intervalId);
                //     }
                // }, 20000);
                // setTimeout(() => {
                //     if (intervalId) {
                //         clearIntervalId(intervalId);
                //         store.dispatch(apiTransitionPaymentsStatus.failure());
                //         //store.dispatch(collectPayloadData());
                //         return;
                //     }
                // }, 120000);
            } catch (e) {
                store.dispatch(apiTransitionStkPush.failure());
                //store.dispatch(triggerPaymentsStkPushFailure(e.response));
                // clearIntervalId(intervalId);
                return e;
            }
        }
    })();
    return result;
};

function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

const stkPushPayload = (state) => {
    const paymentsData = getPaymentsForm(state);
    const premium = getUgxPremium(state);
    const payloadCollectionUUID = getPayloadCollection(state).uuid;
    const msisdn = formatPhoneNumber(paymentsData.phoneNumber.value, '211');
    const networkProvider = paymentsData.networkProvider.value;

    const payload = {
        amount: '100',
        reference_number: payloadCollectionUUID,
        phone_number: msisdn,
    };

    return {
        ...payload,
    };
};

const triggerStkPush = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ss/payments/stk';
        return await axios.post(url, stkPushPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        store.dispatch(triggerPaymentsStkPushFailure(e?.response?.data || {}));
        throw e;
    }
};


const checkPaymentStatus = async (store, transactionReference, uuid) => {
    const MAX_DURATION = 300000; // 5 minutes (300 seconds)
    const INTERVAL = 2000; // 2 seconds
    let elapsedTime = 0;
    const loginData = getAccessToken(store.getState());

    return new Promise((resolve, reject) => {
        const intervalId = setInterval(async () => {
            try {
                const response = await axios.post(
                    `/om-api/travel-ss/payments/stk/status`,
                    {
                        reference: transactionReference,
                        uuid: uuid
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            accessToken: loginData.accessToken,
                        },
                    }
                );

                if (response?.data?.paymentStatus.status === 'SUCCESSFUL') {
                    clearInterval(intervalId);
                    store.dispatch(apiTransitionPaymentsStatus.success());
                    store.dispatch(apiTransitionPayloadCollection.success());
                    resolve(response.data);
                } else if (elapsedTime >= MAX_DURATION) {
                    clearInterval(intervalId);
                    store.dispatch(apiTransitionPaymentsStatus.failure());
                    store.dispatch(apiTransitionPayloadCollection.failure());
                    reject(new Error('Payment verification timed out.'));
                }

                elapsedTime += INTERVAL;
            } catch (error) {
                console.error('Error checking payment status:', error);
            }
        }, INTERVAL);
    });
};
